export const DEFAULT_USERS = [
  { id: 'U001', name: '佐々木 礼央', role: 'admin', avatar: '👔', canManageUsers: true },
  { id: 'U002', name: '柚木 謙一', role: 'staff', avatar: '👤', canManageUsers: false },
];
// PIN はサーバーサイド（Cloudflare 環境変数 USER_PINS）で管理

export const SUPER_ADMIN_ID = 'U001';

export const DEFAULT_STATE = {
  bottle: {},
  sku: {},
  winery: {},
  log: [],
  orders: [],
  users: DEFAULT_USERS,
  customer: {},
  meta: {},
};

export function createDefaultState() {
  return { ...DEFAULT_STATE, users: [...DEFAULT_USERS] };
}

export const DEFAULT_OPERATING_COSTS = [
  { id: 'rent_store', name: '店舗家賃', amount: 330000, category: 'rent' },
  { id: 'rent_warehouse', name: '倉庫', amount: 30000, category: 'rent' },
  { id: 'salary_ceo', name: '宗翠莲（社長）', amount: 351450, category: 'salary' },
  { id: 'salary_director', name: '佐々木明子（役員）', amount: 291943, category: 'salary' },
  { id: 'salary_manager', name: '佐々木礼央（主任）', amount: 293248, category: 'salary' },
  { id: 'transport_yuki', name: '柚木交通費', amount: 15000, category: 'salary' },
  { id: 'electricity', name: '電気代', amount: 15000, category: 'utility' },
  { id: 'telecom', name: '通信費', amount: 6000, category: 'utility' },
  { id: 'accountant', name: '税理士', amount: 33000, category: 'service' },
];
